<template>
    <modal :name="video" class="dd-m-modal">
        <button v-on:click.prevent="toggle()" type="button" class="dd-m-auth__close-btn">
            <i class="dd-m-icon icon-close"></i>
        </button>

        <vue-plyr class="dd-m-video" ref="plyr">
            <div data-plyr-provider="youtube" :data-plyr-embed-id="video"></div>
        </vue-plyr>
    </modal>
</template>

<script>
    import VuePlyr from 'vue-plyr';

    window.Vue.use(VuePlyr);

    export default {
        name: "modal-video",
        data: () => {
            return {
                video: '',
            }
        },
        mounted() {
            this.subscribe();
        },
        methods: {
            subscribe() {
                PubSub.subscribe('video-open', (msg, video) => {
                    this.video = video;
                    setTimeout(() => {
                        this.toggle(true);
                    }, 100);
                });
            },
            toggle() {
                this.$modal.toggle(this.video);
            }
        },
        computed: {
            player() {
                return this.$refs.plyr.player
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/site/js/components/modals/video.vue